module.exports = __webpack_public_path__ + "media/images/logo_pwn_155x32-0cc1fef1738de08ab41275cf62f4b3ed.png";